import { BASE_SERVICE_URL, SETTINGS } from '../../lib/constants'

export default async function newGet(endpoint: string): Promise<Response> {
    return fetch(`${BASE_SERVICE_URL}/${endpoint}`, SETTINGS)
}
